import { useId } from "react";
import { MapPin } from "react-feather";
import { UncontrolledTooltip } from "reactstrap";

const AttendanceTimeBadge = ({ time, kind, location }: {
  time: string | null;
  kind: "in_time" | "out_time";
  location?: string | null;
}) => {
  const tooltipId = `attendance-location-${useId().replace(/:/g, "")}`;
  return <span className="attendance-time-cell">
    <span className={`attendance-time-badge ${time ? (kind === "in_time" ? "is-in" : "is-out") : "is-empty"}`}>{time ?? "–"}</span>
    {location && <>
      <span id={tooltipId} className="attendance-location-pin" tabIndex={0} aria-label={`Location: ${location}`}><MapPin size={15} aria-hidden="true" /></span>
      <UncontrolledTooltip target={tooltipId} placement="top" trigger="hover focus" className="attendance-location-tooltip">{location}</UncontrolledTooltip>
    </>}
  </span>;
};
export default AttendanceTimeBadge;
